import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import ImportarPedidosExcel from '../../components/importarPedidosExcel/ImportarPedidosExcel'
import {submitImportarPedidosExcel, cerrarModalImportarPedidosExcel, subirArchivosImportarPedidosExcel, abrirModalImportarPedidosExcel, descargarPlantillaExcelPedidosExcel} from '../../actions/importarPedidosExcel/importarPedidosExcel'

export function mapStateToProps (state) {
  return {
    ...state.importarPedidosExcel,
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      submitImportarPedidosExcel,
      cerrarModalImportarPedidosExcel,
      subirArchivosImportarPedidosExcel,
      abrirModalImportarPedidosExcel,
      descargarPlantillaExcelPedidosExcel
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ImportarPedidosExcel))